
<script>
    const CouponService = {}

    CouponService.install = function (Vue) {

        var couponService = new Object ();

        Object.defineProperty(Vue.prototype, '$couponService', { value: couponService });

        couponService.search = function (searchQuery, page = 0, size = 10) {
            var url;
            if (searchQuery) {
                url = '/api/admin/coupon?q=' + searchQuery + '&page=' + page + '&size=' + size;
            } else {
                url = '/api/admin/coupon?page=' + page + '&size=' + size;
            }
            return Vue.axios.get(url)
                .then(response => { return response.data; })
                .catch(error => {
                    this.handleError(error)
                    return Promise.reject(error);
            });
        };

        couponService.updateCoupons = function (coupon) {
            var url = '/api/admin/coupon/upsert';
            return Vue.axios.put(url, { coupons: coupon })
                .then(response => { return response.data; })
                .catch(error => {
                    this.handleError(error);
                    return Promise.reject(error);
            });
        };

        couponService.deleteCoupon = function (id) {
            var url = '/api/admin/coupon/delete/' + id;
            return Vue.axios.delete(url)
                .then(response => { console.log(url, response); return response.data; })
                .catch(error => {
                    this.handleError(error);
                    return Promise.reject(error);
            });
        };

        couponService.handleError = function(error) {
            if (error.response) {
                // The request was made and the server responded with a status code that falls out of the range of 2xx
                console.log(error.response.data)
                console.log(error.response.status)
                console.log(error.response.headers)
            } else if (error.request) {
                // The request was made but no response was received `error.request` is an instance of XMLHttpRequest in the browser and an instance of http.ClientRequest in node.js
                // Vue.$router.push('/login')
                console.log('error.request ', error.request)
            } else {
                // Something happened in setting up the request that triggered an Error
                // Vue.$router.push('/login')
                console.log('error', error.request)
            }
        };
    }

    export default CouponService;
</script>